// Examples and syntax reference for the Query page. The query language is parsed by the API
// (api/src/services/investigation/parser.rs); keep this in step with it.

export const EXAMPLES = [
  { query: 'type:hosts package:nginx version:<1.31.0 region:production', text: 'Production hosts running nginx older than 1.31.0' },
  { query: 'type:hosts package:nginx version:1.20.0..1.31.0', text: 'Hosts with an nginx version from 1.20.0 to 1.31.0' },
  { query: 'type:hosts package:nginx* package:!nginx-common', text: 'Hosts with any nginx package except nginx-common' },
  { query: 'type:hosts hostname:*enterprise* package:nginx version:<1.31.0', text: 'Hosts with “enterprise” in the name and an old nginx' },
  { query: 'type:hosts package:nginx team:devops codename:noble', text: 'DevOps hosts on Ubuntu 24.04 (noble) with nginx' },
  { query: 'type:vulns severity:critical,high fix:none', text: 'Critical and high vulnerabilities that have no fix yet' },
  { query: 'type:vulns severity:!low since:7d', text: 'Vulnerabilities above low severity published in the last 7 days' },
  { query: 'type:versions package:openssl region:!bsg', text: 'Installed openssl versions outside BSG' },
  { query: 'type:summary cve:CVE-2024-6197', text: 'Where one CVE is installed, by host and package' },
  { query: 'type:summary host:web-prod-01', text: 'One host’s packages and vulnerabilities' },
];

export const SYNTAX_GROUPS = [
  { title: 'Result types', tokens: ['type:hosts', 'type:packages', 'type:vulns', 'type:versions', 'type:summary'] },
  { title: 'Packages', tokens: ['package:nginx', 'package:nginx*', 'package:*nginx*', 'package:!nginx-common'] },
  { title: 'Versions', tokens: ['version:<1.31.0', 'version:<=1.31.0', 'version:>2.0.0', 'version:>=2.0.0', 'version:1.20.0..1.31.0'] },
  { title: 'Hosts', tokens: ['host:web-prod-01', 'hostname:*enterprise*', 'hostname:!*staging*', 'region:production', 'region:production,enterprise', 'region:!bsg'] },
  { title: 'Infrastructure', tokens: ['team:devops', 'codename:noble', 'codename:noble,jammy', 'os:ubuntu', 'outdated:true', 'has-vulns:true'] },
  { title: 'Vulnerabilities', tokens: ['cve:CVE-2024-6197', 'severity:critical', 'severity:critical,high', 'severity:!low', 'fix:available', 'fix:!available', 'since:7d', 'since:30d'] },
];

// Which filters each kind of query reads; the API warns about the others.
export const FILTERS_BY_QUERY = [
  { title: 'Package queries', filters: 'package, version, region, hostname, team, codename, severity, outdated, has-vulns' },
  { title: 'CVE lookup', filters: 'cve, region, hostname, team, codename, os' },
  { title: 'Vulnerability search', filters: 'severity, package, fix, since, region, hostname, team, codename, os' },
  { title: 'Host summary', filters: 'host, hostname' },
  { title: 'Version overview', filters: 'package, region, hostname, team, codename' },
];

export const TIPS = [
  { token: '*', text: 'Wildcard. At the end it matches the start of a value; on both sides it matches anywhere.' },
  { token: '!', text: 'Excludes matching values.' },
  { token: ',', text: 'Either value: region:production,enterprise.' },
  { token: '..', text: 'Version range, including both ends.' },
  { token: 'k:a k:b', text: 'Repeating a filter requires both: package:nginx* package:!nginx-common.' },
];
